/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListTeamMembersAuthTeamsResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ListTeamMembersAuthTeamsResponse429ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersAuthTeamsResponse429ResponseBodyData;

  constructor(
    err: ListTeamMembersAuthTeamsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersAuthTeamsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListTeamMembersAuthTeamsResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ListTeamMembersAuthTeamsResponse409ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersAuthTeamsResponse409ResponseBodyData;

  constructor(
    err: ListTeamMembersAuthTeamsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersAuthTeamsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListTeamMembersAuthTeamsResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ListTeamMembersAuthTeamsResponse404ResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersAuthTeamsResponse404ResponseBodyData;

  constructor(
    err: ListTeamMembersAuthTeamsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersAuthTeamsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListTeamMembersAuthTeamsResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListTeamMembersAuthTeamsResponseResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersAuthTeamsResponseResponseBodyData;

  constructor(
    err: ListTeamMembersAuthTeamsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersAuthTeamsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListTeamMembersAuthTeamsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListTeamMembersAuthTeamsResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersAuthTeamsResponseBodyData;

  constructor(
    err: ListTeamMembersAuthTeamsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersAuthTeamsResponseBody";
  }
}

/**
 * Bad request
 */
export type ListTeamMembersResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListTeamMembersResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListTeamMembersResponseBodyData;

  constructor(
    err: ListTeamMembersResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListTeamMembersResponseBody";
  }
}

/** @internal */
export const ListTeamMembersAuthTeamsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListTeamMembersAuthTeamsResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListTeamMembersAuthTeamsResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersAuthTeamsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamMembersAuthTeamsResponse429ResponseBody
  > = z.instanceof(ListTeamMembersAuthTeamsResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamMembersAuthTeamsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListTeamMembersAuthTeamsResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListTeamMembersAuthTeamsResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersAuthTeamsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamMembersAuthTeamsResponse409ResponseBody
  > = z.instanceof(ListTeamMembersAuthTeamsResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamMembersAuthTeamsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListTeamMembersAuthTeamsResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListTeamMembersAuthTeamsResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersAuthTeamsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamMembersAuthTeamsResponse404ResponseBody
  > = z.instanceof(ListTeamMembersAuthTeamsResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamMembersAuthTeamsResponseResponseBody$inboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListTeamMembersAuthTeamsResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListTeamMembersAuthTeamsResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersAuthTeamsResponseResponseBody$outboundSchema:
  z.ZodType<
    ListTeamMembersAuthTeamsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListTeamMembersAuthTeamsResponseResponseBody
  > = z.instanceof(ListTeamMembersAuthTeamsResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListTeamMembersAuthTeamsResponseBody$inboundSchema: z.ZodType<
  ListTeamMembersAuthTeamsResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamMembersAuthTeamsResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamMembersAuthTeamsResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersAuthTeamsResponseBody$outboundSchema: z.ZodType<
  ListTeamMembersAuthTeamsResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamMembersAuthTeamsResponseBody
> = z.instanceof(ListTeamMembersAuthTeamsResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));

/** @internal */
export const ListTeamMembersResponseBody$inboundSchema: z.ZodType<
  ListTeamMembersResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListTeamMembersResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListTeamMembersResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListTeamMembersResponseBody$outboundSchema: z.ZodType<
  ListTeamMembersResponseBody$Outbound,
  z.ZodTypeDef,
  ListTeamMembersResponseBody
> = z.instanceof(ListTeamMembersResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
